import { OrganizationContact } from '@data-access/organizations/types';
import {
  patchState,
  signalStoreFeature,
  type,
  withMethods,
} from '@ngrx/signals';
import {
  addEntity,
  entityConfig,
  removeEntity,
  setAllEntities,
  withEntities,
} from '@ngrx/signals/entities';

const _organizationContactEntityConfig = entityConfig({
  collection: '_organizationContact',
  entity: type<OrganizationContact>(),
  selectId: (entity) => entity.id,
});

export const withOrganizationContactEntities = () => {
  return signalStoreFeature(
    withEntities(_organizationContactEntityConfig),

    withMethods(({ _organizationContactEntities, ...store }) => ({
      loadOrganizationContactEntities: (data: OrganizationContact[]) =>
        patchState(
          store,
          setAllEntities(data, _organizationContactEntityConfig),
        ),

      addOrganizationContactEntity: (contact: OrganizationContact) =>
        patchState(store, addEntity(contact, _organizationContactEntityConfig)),

      updateOrganizationContactEntity: (
        oldId: string,
        contact: OrganizationContact,
      ) => {
        patchState(
          store,
          removeEntity(oldId, _organizationContactEntityConfig),
        );
        patchState(store, addEntity(contact, _organizationContactEntityConfig));
      },

      removeOrganizationContactEntity: (id: string) =>
        patchState(store, removeEntity(id, _organizationContactEntityConfig)),

      removeOrganizationContactEntitiesByRelationshipId: (
        relationshipId: string,
      ) => {
        const entities = _organizationContactEntities();
        const filteredEntities = entities.filter((entity) => {
          const entityRelationshipId = entity.relationship_id ?? '';

          // Remove the affiliation card (id and relationship_id are both relationship_id).
          return (
            entityRelationshipId !== relationshipId &&
            entity.id !== relationshipId
          );
        });

        patchState(
          store,
          setAllEntities(filteredEntities, _organizationContactEntityConfig),
        );
      },
    })),
  );
};
